import { type ComponentProps } from 'react'

import { FilterSubmitButton, useFilterFormError } from '@/components/common/Filter'
import { InputText } from '@/components/common/Input'
import { type CardFilterSearchPartialType, type CardFilterSearchSlugType } from '@/defs/cardFilters'

import styles from './GalleryCardFiltersFormSearch.module.scss'

const CONFIG: Record<CardFilterSearchSlugType, Partial<ComponentProps<typeof InputText>>> = {
  cardName: {
    'aria-label': 'Search for a card name',
    placeholder: 'Search card names...',
  },
  typeLine: {
    'aria-label': 'Search for a type line',
    placeholder: 'Search type lines...',
  },
}

type Props = {
  cardFilter: CardFilterSearchPartialType
  onUpdate: (f: CardFilterSearchPartialType) => void
}

export const GalleryCardFiltersFormSearch = ({ cardFilter, onUpdate }: Props) => {
  const { search } = cardFilter
  const searchError = useFilterFormError(!search)

  const onUpdateSearch = (search: string) => {
    onUpdate({ ...cardFilter, search })
  }

  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <InputText
          {...CONFIG[cardFilter.slug]}
          autoFocus
          borderColor={searchError.warn ? 'warning' : undefined}
          colorScheme='muted'
          onChange={onUpdateSearch}
          value={search}
          wiggle={searchError.wiggle}
        />
      </div>
      <FilterSubmitButton />
    </div>
  )
}
